/*############################################################################*/
/*
JS STARTUP
*/
/*############################################################################*/

$(document).ready(function () {
    //Initialize Dropdowns
    Log_Initialize();
    DropDown_Initialize();
    
    Responsive_Initialize();
});

//init Responsive Actions
Responsive_Initialize = function () {
    $('#hamburger').each(function () {
        $(this).click(function (e) {
            $(this).parent().toggleClass("eat");
        });
    });
};

// init the jog plugin
Log_Initialize = function() {
    //if enabled in appsettings
    $.jog().removeHandlers("console");

    if (enableLogView) {
        $.jog.knownHandlers.html.config({ htmlId: 'logView', insertHtml: Log_InsertHtml() });
        $.jog().handlers($.jog.knownHandlers.html);

        //postition logview window
        $("#logView").dialog({ position: ['right', 'top'], width: 450, height: 800, maxHeight: 1024 });
    }
};

Log_InsertHtml = function() {
    var top = $("<div id='logView' title='LogView'></div>");
    $(document.body).append(top);
    return top;
};

DropDown_Initialize = function () {
    var theQueue = $({});

    $.theQueue = function(dropDown) {
        theQueue.queue(function() {
            try {
                dropDown.selectmenu({
                    style: 'dropdown',
                    maxHeight: 400,
                    icons: [
                        { find: '.fontOption' }
                    ]
                });

            } catch(e) {
                alert(e.message);
            }
            $(this).dequeue();
        });
    };

    $("select.smdd").each(function (idx) {
        $.theQueue($(this));
    });
};

/**
    * Adds a new parameter to url. 
    * Decides how to join the parameter to the url (? vs &).
    *
    * @param url
    * @param param e.g. 'q=test'
    */
addParameterToUrl = function (url, param) {
    _url = url;
    _url += (_url.split('?')[1] ? '&' : '?') + param;
    return _url;
}


/** 
* Returns true if the user hit Esc or navigated away from the
* current page before an AJAX call was done. (The response
* headers will be null or empty, depending on the browser.) 
* 
* NOTE: this function is only meaningful when called from 
* inside an AJAX "error" callback! 
* 
* The 'xhr' param is an XMLHttpRequest instance. 
*/
function userAborted(xhr) {
    if (typeof xhr.getAllResponseHeaders === "function") {
        return !xhr.getAllResponseHeaders();

    }
}
